<div class="grid grid-cols-1 gap-4 gap-y-0" [formGroup]="otherCommentsForm">
	<div class="form-element">
		<label
			>Comments for <strong>{{ maneuver }}</strong></label
		>
		<textarea
			#otherComments
			class="border-bg-grey-20 mt-3 h-[360px] w-full border p-4"
			placeholder="Add comment..."
			formControlName="otherComents"
			[attr.maxlength]="getCommentMaxLength()"
		></textarea>
		@if (otherComentsVal) {
			<p class="text-right">
				<span class="text-grey-90 text-[10px]">{{ commentLengthLabel(otherComentsVal.value.length) }}</span>
			</p>
		}
		@if (commentAiAssist && otherComentsVal) {
			<app-comment-ai-assist-toolbar
				[commentControl]="otherComentsVal"
				(replace)="onReplaceSave()"
			></app-comment-ai-assist-toolbar>
		}
	</div>
</div>
